import { render, staticRenderFns } from "./LeaveManageAdminList.vue?vue&type=template&id=061d9df4"
import script from "./LeaveManageAdminList.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdminList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports